export default "__VITE_ASSET__CSYX_D2o__"